import { TranslationMessages } from '../types';
import { app } from './app/pt';
import { settingsApp } from './app/pt';

const pt: TranslationMessages = {
  nav: {
    howItWorks: 'Como funciona',
    why: 'Porquê?',
    features: 'Funcionalidades',
    getStarted: 'COMEÇAR',
    dashboard: 'Painel',
    blog: 'Blog',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Receba pagamentos facilmente',
    subtitle: 'Crie links de pagamento instantaneamente, gere o seu saldo e levante em TON. Taxa da plataforma de 3%.',
    cta: 'Começar',
    hairsim: 'Simule o seu transplante capilar',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Link de pagamento criado.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Subscrição mensal',
    stars: 'Stars',
    payBtn: 'Pagar 100 Stars',
    iPayNow: 'Pago agora',
    paymentLabel: 'Pagamento Telegram Stars',
    merchant: 'Comerciante',
    amount: 'Montante',
    confirmPay: 'Confirmar pagamento',
    paymentReceived: 'Pagamento recebido — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · creditado no saldo',
    thanks: 'Obrigado, acesso ativado',
    messagePlaceholder: 'Mensagem',
  },
  stats: {
    title: 'Confiado por milhares de agentes',
    subtitle: 'Junte-se a uma comunidade crescente de comerciantes que utilizam pagamentos Telegram Stars',
    activeAgents: 'Agentes ativos',
    transactions: 'Transações',
    uptime: 'Disponibilidade',
    support: 'Suporte',
  },
  features: {
    title: 'Tudo o que precisa para aceitar pagamentos Telegram Stars',
    subtitle: 'Uma plataforma completa para gerir os seus pagamentos Telegram Stars',
    instantTitle: 'Criação instantânea',
    instantDesc: 'Torne-se agente em segundos. Sem configuração necessária.',
    balanceTitle: 'Gestão de saldo',
    balanceDesc: 'Acompanhe as suas receitas em tempo real com um painel intuitivo.',
    paymentsTitle: 'Pagamentos Telegram Stars',
    paymentsDesc: 'Aceite pagamentos em Telegram Stars através do seu bot.',
    securityTitle: 'Segurança máxima',
    securityDesc: 'Registo imutável, transações seguras e transparentes.',
    withdrawTitle: 'Levantamentos TON',
    withdrawDesc: 'Levante os seus fundos diretamente para o seu endereço TON.',
    apiTitle: 'API robusta',
    apiDesc: 'Integração fácil com webhooks e uma API REST completa.',
  },
  how: {
    title: 'Como funciona',
    subtitle: 'Comece em 3 passos simples',
    startDemo: 'Iniciar demonstração',
    demoRunning: 'Demonstração em curso...',
    reset: 'Repor',
    step1Title: '1. Registe-se',
    email: 'Email',
    password: 'Palavra-passe',
    noCard: '✓ Sem cartão de crédito necessário',
    step2Title: '2. Criar links de pagamento',
    amountStars: 'Montante (Stars)',
    generatedLink: 'Link gerado:',
    shareLink: '✓ Partilhe este link com os seus clientes',
    step3Title: '3. Levantar os seus fundos',
    tonAddress: 'Endereço TON',
    availableBalance: 'Saldo disponível:',
    fee: 'Taxa: 3%',
  },
  pricing: {
    title: 'Preços simples e transparentes',
    subtitle: 'Sem taxas ocultas, sem compromisso',
    commission: 'Comissão',
    perTransaction: 'por transação',
    freeAccount: 'Criação de conta gratuita',
    noMonthly: 'Sem taxas mensais',
    tonWithdrawals: 'Levantamentos TON integrados',
    completeDashboard: 'Painel completo',
    support247: 'Suporte 24/7',
    startNow: 'Começar agora',
  },
  faq: {
    title: 'Perguntas frequentes',
    subtitle: 'Tudo o que precisa de saber sobre pagamentos Telegram Stars',
    q1: 'Como funciona o pagamento Telegram Stars?',
    a1: 'O pagamento Telegram Stars permite que comerciantes aceitem pagamentos diretamente através do Telegram. Os utilizadores criam links de pagamento, partilham-nos com clientes e recebem pagamentos na moeda Telegram Stars.',
    q2: 'Qual é a taxa da plataforma?',
    a2: 'A taxa da plataforma é de 3% por transação. Isto cobre o processamento de pagamentos, gestão do registo e manutenção da plataforma. Não há taxas de configuração nem custos mensais.',
    q3: 'Como levanto os meus Telegram Stars?',
    a3: 'Pode solicitar levantamentos para a sua carteira TON. Os levantamentos são processados manualmente por segurança. O levantamento mínimo é de 100 Stars.',
    q4: 'O pagamento Telegram Stars é seguro?',
    a4: 'Sim, todos os pagamentos são processados através do sistema de pagamento seguro do Telegram. Utilizamos encriptação padrão da indústria e práticas de segurança.',
    q5: 'O que são Telegram Stars?',
    a5: 'Telegram Stars é uma moeda virtual utilizada no Telegram para pagamentos. Os utilizadores podem comprar Stars e usá-los para pagar serviços, produtos e subscrições.',
    q6: 'Posso usar pagamentos Telegram Stars para o meu negócio?',
    a6: 'Sim! A Telegram Stars Payment Platform foi concebida para comerciantes, criadores e empresas. Pode aceitar pagamentos por produtos digitais, serviços, subscrições e muito mais.',
  },
  cta: {
    title: 'Pronto para começar?',
    subtitle: 'Junte-se a milhares de agentes que já utilizam a nossa plataforma',
    createAccount: 'Criar conta gratuita',
    signIn: 'Iniciar sessão',
  },
  footer: {
    description: 'Plataforma SaaS completa para pagamentos Telegram Stars',
    product: 'Produto',
    features: 'Funcionalidades',
    pricing: 'Preços',
    support: 'Suporte',
    signIn: 'Iniciar sessão',
    docs: 'Documentação',
    copyright: '© 2024 Telegram Stars Payment Platform. Todos os direitos reservados.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Aceite pagamentos via Telegram Stars',
    description: 'Aceite pagamentos via Telegram Stars. Crie links de pagamento instantaneamente, gere o seu saldo e levante em TON. Taxa da plataforma de 3%. Comece a aceitar pagamentos Telegram Stars hoje.',
    keywords: 'pagamento telegram stars, aceitar telegram stars, telegram stars payment platform, gateway pagamentos telegram stars',
  },
  whyPage: {
    seoTitle: 'Porquê escolher Telegram Stars Payment Platform | Vantagens',
    seoDescription: 'Descubra porque comerciantes e criadores escolhem a Telegram Stars Payment Platform: configuração instantânea, preços transparentes, pagamentos seguros e alcance global.',
    title: 'Porquê escolher-nos?',
    subtitle: 'Criado para comerciantes e criadores que querem pagamentos Telegram Stars simples',
    r1Title: 'Configuração instantânea',
    r1Desc: 'Comece em segundos. Sem configuração complexa ou conhecimentos técnicos necessários.',
    r2Title: 'Preços transparentes',
    r2Desc: 'Apenas 3% por transação. Sem taxas ocultas, sem custos mensais, sem taxas de configuração.',
    r3Title: 'Seguro e fiável',
    r3Desc: 'Construído sobre a infraestrutura de pagamento segura do Telegram com encriptação padrão da indústria.',
    r4Title: 'Alcance global',
    r4Desc: 'Aceite pagamentos de utilizadores Telegram em todo o mundo. Sem restrições geográficas.',
    r5Title: 'Integração fácil',
    r5Desc: 'API simples e webhooks. Integre com os seus sistemas existentes em minutos.',
    r6Title: 'Levantamentos TON',
    r6Desc: 'Levante diretamente para a sua carteira TON. Levantamentos rápidos e seguros.',
  },
  howPage: {
    seoTitle: 'Como funciona | Telegram Stars Payment Platform',
    seoDescription: 'Saiba como aceitar pagamentos via Telegram Stars em 3 passos simples. Crie a sua conta, gere links de pagamento e levante em TON.',
    title: 'Como funciona',
    subtitle: 'Aceite pagamentos Telegram Stars em três passos simples',
  },
  settings: {
    title: "Definições",
    languageSection: "Idioma",
    defaultLanguage: "Idioma predefinido",
    languageHint: "Este idioma aplica-se a toda a plataforma (páginas e interface).",
    languageSaved: "Idioma atualizado",
    ...settingsApp,
  },
  app,
};

export default pt;
